import { Injectable } from '@angular/core';
import {
  ConfigInitializerService,
  getContextParameterDefault,
  LANGUAGE_CONTEXT_ID,
  LanguageInitializer,
  LanguageService,
  LanguageStatePersistenceService,
  SiteContextConfig,
} from '@spartacus/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';

@Injectable({ providedIn: 'root' })
export class CustomLanguageInitializer extends LanguageInitializer {
  constructor(
    protected cookieService: SsrCookieService,
    languageService: LanguageService,
    languageStatePersistenceService: LanguageStatePersistenceService,
    configInit: ConfigInitializerService
  ) {
    super(languageService, languageStatePersistenceService, configInit);
  }

  protected override setDefaultFromConfig(config: SiteContextConfig) {
    if (!this.languageService.isInitialized()) {
      let langToSet: string | undefined;

      langToSet = this.cookieService.get('lang');
      if (!langToSet) {
        langToSet = getContextParameterDefault(config, LANGUAGE_CONTEXT_ID);
      }

      if (langToSet) {
        this.languageService.setActive(langToSet);
      }
    }
  }
}
